import * as React from "react";
import {
  Block,
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  Link,
  BlockTitle,
  Card,
  Col,
  Row,
} from "framework7-react";

export default class HomePage extends React.Component {
  public render() {
    return (
      <Page>
        <Navbar>
          <NavLeft leftBreakpoint={800}>
            <Link panelOpen="left">
              <i className="icon icon-menu" />
            </Link>
          </NavLeft>
          <NavTitle>Inicio</NavTitle>
          {/* <NavRight>
            <Link iconIos="f7:menu" iconMd="material:menu" panelOpen="right" />
          </NavRight> */}
        </Navbar>
        <BlockTitle>Notificaciones</BlockTitle>
        <Block>
          <Row resizable={true}>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="Precios"
                content="Se han Actualizado los precios de 15 productos."
              />
            </Col>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="Ultima Actualización"
                content="Modelo CE250/CB435A COMP-AI."
                footer="De $299 a $399."
              />
            </Col>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="Alerta A"
                content="20 Productos de competidores han cambiado su precio."
              />
            </Col>
            <Col className={"medium-50"}>
              <Card
                outline={true}
                title="Alerta B"
                content="El competidor Techtoner añadio 5 productos nuevos."
              />
            </Col>
          </Row>
        </Block>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/HomePage.tsx